'use strict';

// For Einstein recommenders that load tiles after pageload
function initRecommendationSlider() {
    var $lazyCarousel = $('.slick-carousel--lazy:not(.slick-initialized)');
    if ($lazyCarousel.length > 0) {
        $lazyCarousel.find('[data-pid="null"').closest('.recommendation-tile').remove();
        var slickConfigs = $lazyCarousel.closest('[data-slick]').data('slick');
        $lazyCarousel.slick(slickConfigs);
    }
}

module.exports = {
    slickInit: function () {
        $('.slick-carousel:not(.slick-carousel--lazy)').slick();

        $('body').on('initRecommendationSlider', initRecommendationSlider);
    }
}